import {
    DataGrid,
    GridActionsCellItem,
    GridToolbarContainer,
  } from "@mui/x-data-grid";
  import React, { useEffect, useState } from "react";
  import { useSelector } from "react-redux";
  import { getFIles, GetUsers, fetchFile, downloadFiles } from "../../Services/api";
  import instance from "../../redux/api";
  import { CommonButton } from "../common/commonButton";
  import format from 'date-fns/format';
  import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormLabel,
    Grid,
    IconButton,
    MenuItem,
    Select,
    Stack,
    TableContainer,
    TextField,
    Tooltip,
    Typography,
  } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonSelect, CommonPaginationContainer, CommonFilterSidebar } from "../common";
import { getPaginationCount } from "../CashAllocation/utils";  
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import * as XLSX from "xlsx";
import { CircularProgress } from "@mui/material";
import { downloadFileModdules } from "../CashAllocation/constants";
import { commonToast } from "../common";
import {
  downloadButtonStyle,
  primaryButtonHoverColor,
  primaryBlueColor,
} from "../common/commonButtonStyles";
import "../common/commonPageStyles.css";
import FilterListIcon from "@mui/icons-material/FilterList";
  
  export default function FileManagement() {
    // Selectors
    const toggle = useSelector((state) => state.toggleSideMenu);
    const { userData } = useSelector((state) => state?.user);
    
    const Container = {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: 0,
        height: "calc(100vh - 180px)",
        maxHeight: "calc(100vh - 180px)",
        overflow: "hidden",
        position: "relative",
      };

    const [tableRows, setTableRows] = useState([]);
    const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [fromDateValue, setFromDateValue] = useState("");
    const [toDateValue, setToDateValue] = useState("");
    const [isDownloading, setIsDownloading] = useState([]);
    const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  
    const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
    const classes = useStyles();
    const [searchFieldsPrams, setSearchFieldsPrams] = useState({
      File_Name: "",
      Module_Name: "",
      Uploaded_At: "",
      Uploaded_By: null,
    });
    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    const [isClearPerformed, setIsClearPerformed] = useState(false);
  
    //For pagination
    const [paginationCount, setPaginationCount] = useState(0);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [pageState, setPageState] = useState({
      isLoading: true,
      data: [],
      total: 0,
      page: 1,
      pageSize: 25,
    });
  
    const UserAuthorisation =
      userData?.user_permissions?.permissions_list['Admin Table Maintenance'];
    // skip 0 means page 1
    const currentSkipNumber = () => {
      return pageState?.page === 1
        ? 0
        : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
    };
  
    useEffect(() => {
      setPaginationCount(
        getPaginationCount(pageState?.total, pageState?.pageSize),
      );
    }, [pageState?.pageSize, pageState?.total]);

    useEffect(() => {
      loadData();
    }, [pageState?.pageSize, pageState?.page]);

    useEffect(() => {
      if (!isClearPerformed) {
        loadData();
      }
    }, [pageState?.pageSize, pageState?.page]);

    useEffect(() => {
      if (isClearPerformed) {
        loadData();
        setIsClearPerformed(false);
      }
    }, [isClearPerformed]);

    useEffect(() => {
      if (isSearchPerformed) {
        const searchFields = searchFieldsPrams;
        if (Object.values(searchFields).every(value => !value) && !toDateValue && !fromDateValue) {
          handleClearSearchList();
        }
      }
    }, [toDateValue, fromDateValue]);

    const handleFieldsInputChange = (name, value) => {
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        [name]: value ?? "",
      });
      if (isSearchPerformed && !value) {
        const searchFields = searchFieldsPrams;
        delete searchFields[name];
        if (Object.values(searchFields).every(value => !value) && !toDateValue && !fromDateValue) {
          handleClearSearchList();
        }
      }
    };

    const handleSearchFiles = async () => {
      try {
        let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;
  
        const { File_Name, Module_Name, Uploaded_At, Uploaded_By } = searchFieldsPrams;
        if (File_Name) {
          queryParams = `${queryParams}&file_name=${File_Name}`;
        }
  
        if (Module_Name) {
          queryParams = `${queryParams}&module_name=${Module_Name}`;
        }
  
        if (Uploaded_At) {
          queryParams = `${queryParams}&uploaded_at=${Uploaded_At}`;
        }
  
        if (fromDateValue) {
          const formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
          queryParams = `${queryParams}&from_date=${formattedFromDateValue}`;
        }
  
        if (toDateValue) {
          const formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
          queryParams = `${queryParams}&to_date=${formattedToDateValue}`;
        }
  
        if (Uploaded_By) {
          queryParams = `${queryParams}&uploaded_by=${Uploaded_By.id}`;
        }
  
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
  
        const response = await instance.get(`${getFIles}${queryParams}`);
  
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        if (response.status === 200) {
          console.log("broker", response);
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ?? [],
            page: 1
          }));
          setIsSearchPerformed(true);
          setPaginationCount(
            Math.floor(response?.data?.count / pageState?.pageSize)
          );
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count ?? 0,
            data: [],
          }));
          setPaginationCount(0);
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        console.log("err", err);
      }
    };

    const handleClearSearchList = () => {
      setIsSearchPerformed(false);
      setSearchFieldsPrams({
        File_Name: "",
        Module_Name: "",
        Uploaded_At: "",
        Uploaded_By: null,
      });
      setFromDateValue("");
      setToDateValue("");
      setPageState((old) => ({
        ...old,
        page: 1
      }));
      setIsClearPerformed(true);
    };

    const handleApplyFilters = () => {
      handleSearchFiles();
    };

    const handleClearFilters = () => {
      handleClearSearchList();
    };

    useEffect(() => {
      loadUserData()
    }, [])

    const loadUserData = async () => {
      try {
        // setUsers
        await instance.get(`${GetUsers}`).then((response) => {
          const filteredUsers = response.data.filter(
            (user) => user.status === "Active"
          );
          setUsers([...new Set(filteredUsers)]);
        })
          
          // setUsers(response.data))
        .catch((error) => console.error("Error : ", error));
      } catch (err) {
        console.error("Error : ", err)
      }
    }
  
    const loadData = async () => {
      try {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));

        let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

        if (isSearchPerformed) {
          const { File_Name, Module_Name, Uploaded_By, Uploaded_At } = searchFieldsPrams;

          if (File_Name) {
            queryParams = `${queryParams}&file_name=${File_Name}`;
          }
          if (Module_Name) {
            queryParams = `${queryParams}&module_name=${Module_Name}`;
          }
          if (Uploaded_By) {
            queryParams = `${queryParams}&uploaded_by=${Uploaded_By.id}`;
          }
          if (Uploaded_At) {
            queryParams = `${queryParams}&uploaded_at=${Uploaded_At}`;
          }
          if (fromDateValue) {
            const formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
            queryParams = `${queryParams}&from_date=${formattedFromDateValue}`;
          }

          if (toDateValue) {
            const formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
            queryParams = `${queryParams}&to_date=${formattedToDateValue}`;
          }
        }
        const response = await instance.get(
          `${getFIles}?${queryParams}`
        );
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        if (response.status === 200) {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ?? [],
          }));
          setPaginationCount(
            Math.floor(response?.data?.count / pageState?.pageSize)
          );
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: [],
          }));
          setPaginationCount(0);
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
        setPaginationCount(0);
        console.error("err", err);
      }
    };
  
    
    const columns = [
      {
        field: "file_name",
        headerName: "File Name",
        // width: 300,
        flex: 3,
        headerAlign: "center",
      },
      {
        field: "module_name",
        headerName: "Module Name",
        // width: 150,
        flex: 1.5,
        headerAlign: "center",
      },
      {
        field: "file_info",
        headerName: "#Records",
        // width: 80,
        flex: 1,
        headerAlign: "center",
        renderCell: (params) => {
          const data = JSON.parse(params.row.file_info);
          return data.record_count;
        }
      },
      {
        field: "file_type",
        headerName: "File Type",
        // width: 80,
        flex: 0.8,
        headerAlign: "center",
      },
      {
        field: "file_size",
        headerName: "File Size",
        // width: 80,
        flex: 1,
        headerAlign: "center",
        renderCell: (params) => (
          <span>{formatFileSize(params?.row?.file_size)}</span>
          ),
      },
      {
        field: "created_by",
        headerName: "Uploaded By",
        // width: 120,
        flex: 1.2,
        headerAlign: "center",
        renderCell: (params) => (
        <span>{params?.row?.created_by?.user_name || ''}</span>
        ),
      },
      {
        field: "created_at",
        headerName: "Uploaded At",
        // width: 120,
        flex: 1.2,
        headerAlign: "center",
        renderCell: (params) => (
            <span>{format(new Date(params.row?.created_at), "dd-MM-yyyy")}</span>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        // width: 120,
        flex: 1.2,
        headerAlign: "center",
        renderCell: (params) => (
              isDownloading.includes(params.row.id) ?
              <CircularProgress
                style={{ color: primaryBlueColor }}
              /> :
              <DownloadIcon
                  style={{ marginRight: 8, cursor: "pointer", color: primaryBlueColor }}
                  titleAccess="Download File"
                  onClick={() => downloadTheFile(params.row.file_name, params.row.module_name, params.row.id)}
              />
        ),
      }
    ];

    const downloadTheFile = async (file_name, module_name, id) => {
      setIsDownloading([
        ...isDownloading,
        id
      ])
      let module = downloadFileModdules.fileManagement;
      if (module_name=='Activity_Refund'){
        module = downloadFileModdules.activity;
      }
      if (module_name=='WF_Bank_Amount_Change'){
        module = downloadFileModdules.workflow;
      }
      const url = `${fetchFile}?key=${encodeURIComponent(file_name)}&moduleName=${module_name}&module=${module}`;

      await instance.get(`${url}`,  { 
        responseType: "blob",
        headers: {
          'Accept': '*/*'
        }
      })
      .then((response) => {
        setIsDownloading(isDownloading.filter(ids => ids !== id))

        // Extract filename from Content-Disposition header if available
        let fileName = file_name;
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            fileName = filenameMatch[1].replace(/['"]/g, '');
          }
        }

        openFileInNewTab(response.data, fileName)
      })
      .catch((error) => {
        setIsDownloading(isDownloading.filter(ids => ids !== id))
        console.error("Error : ", error)
        commonToast("error", "File could not be downloaded");
      });
    }

    function openFileInNewTab(blob, fileName) {

    // Get file extension from filename
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    
    // Determine MIME type based on file extension
    let mimeType = blob.type;
    if (!mimeType || mimeType === 'application/octet-stream') {
      switch(fileExtension) {
        case 'png': mimeType = 'image/png'; break;
        case 'jpg':
        case 'jpeg': mimeType = 'image/jpeg'; break;
        case 'gif': mimeType = 'image/gif'; break;
        case 'pdf': mimeType = 'application/pdf'; break;
        case 'xlsx': mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
        case 'xls': mimeType = 'application/vnd.ms-excel'; break;
        case 'csv': mimeType = 'text/csv'; break;
        case 'doc': mimeType = 'application/msword'; break;
        case 'docx': mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
        default: mimeType = 'application/octet-stream';
      }
    }

    // Create a new blob with the correct MIME type
    const correctedBlob = new Blob([blob], { type: mimeType });
    
    // Try to open in new tab first (for viewable files)
    const viewableTypes = ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];
    if (viewableTypes.includes(mimeType)) {
      const url = window.URL.createObjectURL(correctedBlob);
      const newWindow = window.open(url, '_blank');
      if (newWindow) {
        setTimeout(() => window.URL.revokeObjectURL(url), 1000 * 60);
        return;
      }
    }
    
    // Fallback to download for all files
    const url = window.URL.createObjectURL(correctedBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    
    setTimeout(() => window.URL.revokeObjectURL(url), 1000 * 60);
  }

    const formatFileSize = (bytes) => {
      if(!bytes) return "-";
      if (bytes === 0) return '0 Byte';
      
      const sizes = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(1024)); 
      const fileSize = (bytes / Math.pow(1024, i)).toFixed(2);
      
      return `${fileSize} ${sizes[i]}`;
    }

    const isFilterBtnDisable = () => {
      let disabled = true;
      const { File_Name, Module_Name, Uploaded_By } = searchFieldsPrams;
      if (File_Name !== "" || Module_Name !== "" || Uploaded_By || fromDateValue !== "" || toDateValue !== "") {
        disabled = false;
      }
      return disabled;
    };

    // Handle input change for the search field
    const handleInputChange = (value) => {
        setSearchText(value);
    };

    // Handle change when a user is selected
    // const handleChange = (event, value) => {
    //     setSelectedUser (value);
    // };

    // Filter users based on the search text
    useEffect(() => {
      setFilteredUsers(users.filter(user =>
          user.user_name.toLowerCase().includes(searchText.toLowerCase())
      ));
    }, [searchText, users]);
    
    const handleEnter = (e) => {
      if (e.code === "Enter") {
        handleSearchFiles();
      }
    };
    const handleDownloadBtnClick = () => {
      setIsDownloadInProgress(true);
      try {
        instance
          .get(`${downloadFiles}`, { responseType: "blob" })
          .then((response) => {
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            const fileName = `DocumentRepository_${format(new Date(), "dd-MM-yyyy")}`
            link.setAttribute("download", `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setIsDownloadInProgress(false);
            commonToast("success", "Document Repository data has been downloaded successfully");
          }).catch((err) => {
            console.log(err);
            setIsDownloadInProgress(false);
            commonToast("error", "Document Repository data could not be downloaded");
          });
      } catch (error) {
        setIsDownloadInProgress(false);
        console.log(error);
        commonToast("error", "Document Repository data could not be downloaded");
      }
    }
    
    return (
      <div style={Container}>
        {/* Filter Sidebar */}
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "textInput",
              label: "File Name",
              placeholder: "Enter File Name Here",
              value: searchFieldsPrams?.File_Name || "",
              onChange: (value) => handleFieldsInputChange("File_Name", value),
              onKeyUp: (e) => handleEnter(e),
            },
            {
              type: "textInput",
              label: "Module Name",
              placeholder: "Enter Module Name Here",
              value: searchFieldsPrams?.Module_Name || "",
              onChange: (value) => handleFieldsInputChange("Module_Name", value),
              onKeyUp: (e) => handleEnter(e),
            },
            {
              type: "custom",
              content: (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#000",
                      marginBottom: "12px",
                    }}
                  >
                    Uploaded By
                  </Typography>
                  <CommonSelect
                    options={users}
                    value={searchFieldsPrams?.Uploaded_By}
                    handleChange={(event, value, reason) => handleFieldsInputChange("Uploaded_By", value)}
                    handleInputChage={handleInputChange}
                    placeholder="Select user name"
                    getOptionKey={(option) => option.id ?? option}
                    getOptionLabel={(option) => option.user_name ?? option}
                    customStyles={{ width: "100%" }}
                  />
                </Box>
              ),
            },
            {
              type: "dateRange",
              label: "Uploaded At",
              startDate: fromDateValue,
              setStartDate: setFromDateValue,
              endDate: toDateValue,
              setEndDate: setToDateValue,
              maxDate: new Date(),
            },
          ]}
          onApplyFilters={handleApplyFilters}
          onClearFilters={handleClearFilters}
          isLoading={pageState?.isLoading}
          isFilterDisabled={isFilterBtnDisable()}
        />

        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
              Document Repository
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {UserAuthorisation?.["Creation"] === "Y" && (
                <CommonButton
                  text="Export"
                  handleClick={handleDownloadBtnClick}
                  sx={downloadButtonStyle}
                  hoverColor={primaryButtonHoverColor}
                  disabled={isDownloadInProgress}
                />
              )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              width: "100%",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
            }}
          >
          {/* <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            columns={columns}
            rowCount={pageState?.total}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            paginationMode="server"
            // getRowId={(row) => row?.id}
            getRowId={(row) => pageState?.data.indexOf(row)}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 10}
            rowsPerPageOptions={[2, 10, 25, 50, 100]}
            
            onPageSizeChange={(newPageSize) => {
              // return setPageState((old) => {
              //   console.log("setPaginationCount 5 : ", pageState)
              //   setPaginationCount(Math.floor(pageState.total / newPageSize));
              //   return { ...old, pageSize: newPageSize, page: 1 };
              // });
              return setPageState((old) => {
                setPaginationCount(
                  getPaginationCount(pageState?.total, newPageSize),
                );
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            components={{
              Toolbar: GridToolbarContainer, // Custom toolbar for filter reset button
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No files found
                </Stack>
              ),
            }}
            sx={{
              "& .MuiDataGrid-columnHeader[data-field='actions']": {
                minWidth: toggle?.isOpen
                  ? "106px !important"
                  : "123px !important",
              },
            }}
          />
           <Stack
            style={{
              position: "absolute",
              bottom: "8px",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack> */}
            <DataGrid
              loading={pageState?.isLoading}
              rows={pageState?.data ?? []}
              getRowId={(row) => pageState?.data.indexOf(row)}
              rowCount={pageState?.total}
              columns={columns}
              disableRowSelectionOnClick
              keepNonExistentRowsSelected
              paginationMode="server"
              disableSelectionOnClick
              hideFooterPagination
              hideFooter
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              onPageSizeChange={(newPageSize) => {
                return setPageState((old) => {
                  setPaginationCount(
                    getPaginationCount(pageState?.total, newPageSize),
                  );
                  return { ...old, pageSize: newPageSize, page: 1 };
                });
              }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                width: "100%",
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                  width: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#1672DE",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-row": {
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                  fontSize: "14px",
                  color: "#333",
                  padding: "12px 16px",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1px solid #e0e0e0",
                  backgroundColor: "#f8f9fa",
                },
              }}
              components={{
                Toolbar: () => null,
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    No Uploaded Files
                  </Stack>
                ),
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
                backgroundColor: "#f8f9fa",
                padding: "8px 16px 12px 16px",
                borderTop: "1px solid #e0e0e0",
                minHeight: "56px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography sx={{ fontSize: "14px", color: "#666" }}>
                  Rows per page:
                </Typography>
                <Select
                  value={pageState?.pageSize ?? 25}
                  onChange={(e) => {
                    setPageState((old) => {
                      setPaginationCount(
                        getPaginationCount(pageState?.total, e.target.value),
                      );
                      return { ...old, pageSize: e.target.value, page: 1 };
                    });
                  }}
                  size="small"
                  sx={{
                    minWidth: "80px",
                    height: "32px",
                    fontSize: "14px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d0d0d0",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1672DE",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1672DE",
                    },
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography sx={{ fontSize: "14px", color: "#666" }}>
                  {pageState?.pageSize * (pageState?.page - 1) + 1}-
                  {Math.min(pageState?.pageSize * pageState?.page, pageState?.total)} of {pageState?.total}
                </Typography>
              </Box>
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
              />
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
  